/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, MouseEvent, useEffect, useState, BaseSyntheticEvent } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Button } from '../../../components/Button/Button'
import { Input } from '../../../components/Input/Input'
import { useNavigate, useParams } from 'react-router-dom'
import { Loading } from '../../../components/Loading/Loading'
import { GET, POST, PUT } from '../../../services/api'
import Swal from 'sweetalert2'
import { i18n } from '../../../translate/i18n'
import { BreadCrumbs } from '../../../components/BreadCrumbs/breadCrumbrs'
import uuid from 'react-uuid'
import moment from 'moment-timezone'

enum typeBannerHotel {
  BANNER = 'banner',
  HIGHLIGHT = 'highlight',
}
interface UpdatePublicityHotelDto {
  image?: string
  order: number
  title: string
  type: typeBannerHotel.BANNER
  startDate?: Date | string
  endDate?: Date | string
  status?: boolean
}

interface PublicityHotel {
  id: number
  pluginspaceId: number
  title: string
  image?: string
  order: number
  startDate: string
  endDate: string
  status: boolean
  createdAt: string
  updatedAt: string
}

const ContaContent: FC = () => {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const [loading, setLoading] = useState(true)
  const [image, setImage] = useState<File | string | null>(null)
  const [firstStateImage, setFirstStateImage] = useState<File | string | null>(null)
  const [originalData, setOriginalData] = useState<PublicityHotel | null>(null)

  // Form state
  const [formData, setFormData] = useState<UpdatePublicityHotelDto>({
    image: '',
    title: '',
    type: typeBannerHotel.BANNER,
    order: 1,
    startDate: '',
    endDate: '',
    status: true,
  })

  // Separate date and time states for better UX
  const [startDateOnly, setStartDateOnly] = useState('')
  const [startTimeOnly, setStartTimeOnly] = useState('00:00:00')
  const [endDateOnly, setEndDateOnly] = useState('')
  const [endTimeOnly, setEndTimeOnly] = useState('23:59:00')

  const handleInputChange = (field: keyof UpdatePublicityHotelDto, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }))
  }

  // Update combined datetime when date or time changes
  useEffect(() => {
    if (startDateOnly && startTimeOnly) {
      setFormData(prev => ({
        ...prev,
        startDate: moment(`${startDateOnly}T${startTimeOnly}`).format('YYYY-MM-DDTHH:mm:ss')
      }))
    }
  }, [startDateOnly, startTimeOnly])

  useEffect(() => {
    if (endDateOnly && endTimeOnly) {
      setFormData(prev => ({
        ...prev,
        endDate: moment(`${endDateOnly}T${endTimeOnly}`).format('YYYY-MM-DDTHH:mm:ss')
      }))
    }
  }, [endDateOnly, endTimeOnly])

  const getPublicity = async () => {
    if (!id) return

    try {
      setLoading(true)
      const res = await GET(`/publicity-hotel/${id}`)
      const publicity: PublicityHotel = res.data

      setOriginalData(publicity)


      if (publicity.image) {
        setImage(publicity.image)
        setFirstStateImage(publicity.image)
      }

      // Converter de UTC para o fuso horário de São Paulo para exibição
      const saoPauloTimezone = 'America/Sao_Paulo'

      // Converter dateStart de UTC para São Paulo
      const startDateSP = moment.utc(publicity.startDate)
      console.log(startDateSP)
      setStartDateOnly(startDateSP.format('YYYY-MM-DD'))
      setStartTimeOnly(startDateSP.format('HH:mm:ss'))

      // Converter dateEnd de UTC para São Paulo
      const endDateSP = moment.utc(publicity.endDate)
      setEndDateOnly(endDateSP.format('YYYY-MM-DD'))
      setEndTimeOnly(endDateSP.format('HH:mm:ss'))

      setFormData({
        image: publicity.image || '',
        title: publicity.title,
        type: typeBannerHotel.BANNER,
        order: publicity.order,
        startDate: moment.utc(publicity.startDate).format('YYYY-MM-DD HH:mm:ss'),
        endDate: moment.utc(publicity.endDate).format('YYYY-MM-DD HH:mm:ss'),
        status: publicity.status,
      })

      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_banner_update.error.title')),
        text: String(i18n.t('hospitality_banner_update.error.load_data')),
      }).then(() => {
        navigate('/hospitality/publicity-banner')
      })
    }
  }

  const validateForm = (): boolean => {
    if (formData.order !== undefined && formData.order <= 0) {
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_banner_create.validation.title')),
        text: String(i18n.t('hospitality_banner_create.validation.order_positive')),
      })
      return false
    }

    if (formData.startDate && formData.endDate) {
      const startDateTime = new Date(formData.startDate)
      const endDateTime = new Date(formData.endDate)

      if (startDateTime >= endDateTime) {
        Swal.fire({
          icon: 'error',
          title: String(i18n.t('hospitality_banner_create.validation.title')),
          text: String(i18n.t('hospitality_banner_create.validation.start_before_end')),
        })
        return false
      }
    }

    return true
  }



  const updatePublicidade = async () => {
    if (!validateForm() || !id || !originalData) return

    try {
      setLoading(true)
      const saoPauloTimezone = 'America/Sao_Paulo'

      // Preparar dados para envio (somente campos modificados)
      const dataToSend: UpdatePublicityHotelDto = {
        title: formData.title,
        type: typeBannerHotel.BANNER,
        order: formData.order,
        startDate: moment(`${formData.startDate}`).format(`YYYY-MM-DD HH:mm:ss`),
        endDate: moment(`${formData.endDate}`).format(`YYYY-MM-DD HH:mm:ss`),
        status: formData.status,
      }

      // Se nenhum campo foi modificado
      if (Object.keys(dataToSend).length === 0 && image === firstStateImage) {
        Swal.fire({
          icon: 'info',
          title: String(i18n.t('hospitality_banner_update.no_changes.title')),
          text: String(i18n.t('hospitality_banner_update.no_changes.text')),
        })
        setLoading(false)
        return
      }

      const res = await PUT(`/publicity-hotel/${id}`, dataToSend)

      if (res && res.success) {
        let imageRes = { success: false, image: '' }

        if (image && image !== firstStateImage) {
          if (firstStateImage) {
            await POST('/upload-images/delete-one', {
              url: firstStateImage,
            })
          }
          if (image) {
            const formData = new FormData()
            formData.append('file', image)
            formData.append('nameImage', `publicity-${uuid()}.jpg`)
            formData.append('originalSize', 'true')
            imageRes = await POST('/upload-images/upload-one', formData)
            if (imageRes.success) {
              await PUT(`/publicity-hotel/${id}`, {
                image: imageRes.image,
              })
            }
          }
        }
      }


      if (res.success) {
        Swal.fire({
          icon: 'success',
          title: String(i18n.t('hospitality_banner_update.success.title')),
          text: String(i18n.t('hospitality_banner_update.success.text')),
        }).then(() => navigate('/hospitality/publicity-banner'))
      } else {
        throw new Error(res.message || i18n.t('hospitality_banner_update.error.text'))
      }

      setLoading(false)
    } catch (error: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_banner_update.error.title')),
        text: String(error.message || i18n.t('hospitality_banner_update.error.update')),
      })
      console.error(error)
    }
  }

  useEffect(() => {
    getPublicity()
  }, [id])

  const resizeImage = (file: File, targetWidth: number, targetHeight: number): Promise<File> => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')!
      const img = new Image()

      img.onload = () => {
        const { naturalWidth: width, naturalHeight: height } = img

        // Calcular o crop centralizado
        const sourceRatio = width / height
        const targetRatio = targetWidth / targetHeight

        let sourceWidth, sourceHeight, sourceX, sourceY

        if (sourceRatio > targetRatio) {
          // Imagem mais larga - cortar nas laterais
          sourceHeight = height
          sourceWidth = height * targetRatio
          sourceX = (width - sourceWidth) / 2
          sourceY = 0
        } else {
          // Imagem mais alta - cortar em cima e embaixo
          sourceWidth = width
          sourceHeight = width / targetRatio
          sourceX = 0
          sourceY = (height - sourceHeight) / 2
        }

        // Configurar canvas
        canvas.width = targetWidth
        canvas.height = targetHeight

        // Desenhar imagem redimensionada e cortada no centro
        ctx.drawImage(
          img,
          sourceX, sourceY, sourceWidth, sourceHeight,
          0, 0, targetWidth, targetHeight
        )

        // Converter canvas para blob e depois para File
        canvas.toBlob((blob) => {
          if (blob) {
            const resizedFile = new File([blob], file.name, {
              type: file.type,
              lastModified: Date.now()
            })
            resolve(resizedFile)
          }
        }, file.type, 0.9)
      }

      img.src = URL.createObjectURL(file)
    })
  }

  const validateImage = (file: File): Promise<File | null> => {
    return new Promise((resolve) => {
      // Verificar tamanho do arquivo (máximo 2MB)
      const maxSizeInBytes = 2 * 1024 * 1024 // 2MB
      if (file.size > maxSizeInBytes) {
        Swal.fire({
          icon: 'warning',
          title: String(i18n.t('hospitality_publicity_create.validation.title')),
          text: String(i18n.t('hospitality_publicity_create.validation.image_size_error')),
        })
        resolve(null)
        return
      }

      // Verificar dimensões da imagem
      const img = new Image()
      img.onload = async () => {
        const width = img.naturalWidth
        const height = img.naturalHeight

        // Dimensões esperadas: aproximadamente 200x112 (tolerância de ±10%)
        const expectedWidth = 1350
        const expectedHeight = 500
        const tolerance = 0.1 // 10%

        const minWidth = expectedWidth * (1 - tolerance)
        const maxWidth = expectedWidth * (1 + tolerance)
        const minHeight = expectedHeight * (1 - tolerance)
        const maxHeight = expectedHeight * (1 + tolerance)

        if (width < minWidth || width > maxWidth || height < minHeight || height > maxHeight) {
          // Perguntar se o usuário quer redimensionar
          const result = await Swal.fire({
            icon: 'question',
            title: String(i18n.t('hospitality_publicity_create.validation.title')),
            html: `
              <p>${String(i18n.t('hospitality_publicity_create.validation.image_dimensions_error', {
              current: `${width}x${height}`,
              expected: `${expectedWidth}x${expectedHeight}`
            }).replace('200x112', `${expectedWidth}x${expectedHeight}`))}</p>
              <p><strong>Deseja redimensionar a imagem automaticamente?</strong></p>
              <p><small>A imagem será cortada no centro para se ajustar às dimensões necessárias.</small></p>
            `,
            showCancelButton: true,
            confirmButtonText: 'Sim, redimensionar',
            cancelButtonText: 'Não, escolher outra imagem',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
          })

          if (result.isConfirmed) {
            try {
              const resizedFile = await resizeImage(file, expectedWidth, expectedHeight)
              resolve(resizedFile)
            } catch (error) {
              Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Ocorreu um erro ao redimensionar a imagem. Tente novamente.',
              })
              resolve(null)
            }
          } else {
            resolve(null)
          }
          return
        }

        resolve(file)
      }

      img.onerror = () => {
        Swal.fire({
          icon: 'warning',
          title: String(i18n.t('hospitality_publicity_create.validation.title')),
          text: String(i18n.t('hospitality_publicity_create.validation.image_invalid')),
        })
        resolve(null)
      }

      img.src = URL.createObjectURL(file)
    })
  }


  if (loading) {
    return <Loading />
  }

  if (!originalData) {
    return (
      <div className='alert alert-danger'>
        <h4>{i18n.t('hospitality_banner_update.not_found.title')}</h4>
        <p>{i18n.t('hospitality_banner_update.not_found.text')}</p>
        <Button
          text={i18n.t('hospitality_banner_update.not_found.back_button')}
          color='primary'
          size='small'
          click={() => navigate('/hospitality/publicity-banner')}
        />
      </div>
    )
  }

  if (loading) return <Loading />


  return (
    <>


      <div className='card py-4 px-11'>
        <div className='row'>
          <div>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t('hospitality_banner_update.page_title')}</span>
              <BreadCrumbs />
              <span className='text-muted mt-1 fw-bold fs-7'>
                {i18n.t('hospitality_banner_update.page_subtitle', { id: originalData.id })}
              </span>
            </h3>
          </div>

          <div className='col-12 mt-8'>
            <div className='row'>
              <div className='row'>
                {/* Ordem e Status */}

                <div className='col-md-5'>
                  <Input
                    inputAttr={{
                      type: 'text',
                      min: '1',
                    }}
                    label={i18n.t('hospitality_banner_create.form.title_label')}
                    placeholder={i18n.t('hospitality_banner_create.form.title_placeholder')}
                    value={formData.title.toString()}
                    change={(value: string) => handleInputChange('title', value)}
                    maxLength='50'
                    required
                  />
                </div>

                <div className='col-md-4'>
                  <Input
                    inputAttr={{
                      type: 'number',
                      min: '1',
                    }}
                    label={i18n.t('hospitality_banner_create.form.order_label')}
                    placeholder={i18n.t('hospitality_banner_create.form.order_placeholder')}
                    value={formData.order.toString()}
                    change={(value: string) => handleInputChange('order', parseInt(value) || 1)}
                    smalltext={i18n.t('hospitality_banner_create.form.order_smalltext')}
                    required
                  />
                </div>

                <div className='col-md-3 d-flex align-items-end'>
                  <Input
                    inputAttr={{
                      type: 'checkbox',
                    }}
                    label={i18n.t('hospitality_banner_create.form.status_label')}
                    checked={formData.status}
                    change={(checked: boolean) => handleInputChange('status', checked)}
                    checkSwift
                    smalltext={i18n.t('hospitality_banner_create.form.status_smalltext')}
                  />
                </div>
              </div>

              <div className='col-md-6 d-flex align-items-end'>
                <Input
                  inputAttr={{
                    type: 'checkbox',
                  }}
                  label={i18n.t('hospitality_banner_create.form.status_label')}
                  checked={formData.status}
                  change={(checked: boolean) => handleInputChange('status', checked)}
                  checkSwift
                  smalltext={i18n.t('hospitality_banner_create.form.status_smalltext')}
                />
              </div>
            </div>

            {/* Datas */}
            <div className='row mt-4'>
              <div className='col-md-6'>
                <Input
                  inputAttr={{
                    type: 'date',
                  }}
                  label={i18n.t('hospitality_banner_create.form.start_date_label')}
                  value={startDateOnly}
                  change={(value: string) => setStartDateOnly(value)}
                  required
                />
              </div>

              <div className='col-md-6'>
                <Input
                  inputAttr={{
                    type: 'time',
                  }}
                  label={i18n.t('hospitality_banner_create.form.start_time_label')}
                  value={startTimeOnly}
                  change={(value: string) => setStartTimeOnly(value)}
                  required
                />
              </div>
            </div>

            <div className='row mt-4'>
              <div className='col-md-6'>
                <Input
                  inputAttr={{
                    type: 'date',
                  }}
                  label={i18n.t('hospitality_banner_create.form.end_date_label')}
                  value={endDateOnly}
                  change={(value: string) => setEndDateOnly(value)}
                  required
                />
              </div>

              <div className='col-md-6'>
                <Input
                  inputAttr={{
                    type: 'time',
                  }}
                  label={i18n.t('hospitality_banner_create.form.end_time_label')}
                  value={endTimeOnly}
                  change={(value: string) => setEndTimeOnly(value)}
                  required
                />
              </div>
            </div>

            {/* Preview das datas */}
            {formData.startDate && formData.endDate && (
              <div className='row mt-3'>
                <div className='col-12'>
                  <div className='alert alert-info'>
                    <h6 className='mb-2'>📅 {i18n.t('hospitality_banner_create.preview.period_title')}</h6>
                    <p className='mb-1'>
                      <strong>{i18n.t('hospitality_banner_create.preview.start')}:</strong> {new Date(formData.startDate).toLocaleString('pt-BR')}
                    </p>
                    <p className='mb-0'>
                      <strong>{i18n.t('hospitality_banner_create.preview.end')}:</strong> {new Date(formData.endDate).toLocaleString('pt-BR')}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Upload de Imagem */}
            <div className='row mt-6'>
              <div className='col-md-6'>
                <div className='mb-4'>
                  <label className='form-label fw-bold'>{i18n.t('hospitality_banner_create.form.image_label')}</label>
                  <div className='border border-dashed border-primary p-6 text-center rounded'>

                    {image && typeof image !== 'string' && (
                      <div className='col-md-6'>
                        <label className='form-label'>{i18n.t('hospitality_banner_create.form.image_preview')}</label>
                        <div className='border rounded p-3'>
                          <img
                            src={URL.createObjectURL(image)}
                            alt='Preview'
                            style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'cover' }}
                          />
                        </div>
                      </div>
                    )}
                    {image && typeof image === 'string' && (
                      <div className='col-md-6'>
                        <label className='form-label'>{i18n.t('hospitality_banner_update.current_image')}</label>
                        <div className='border rounded p-3'>
                          <img
                            src={image}
                            alt={i18n.t('hospitality_banner_update.current_image')}
                            style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'cover' }}
                          />
                        </div>
                      </div>
                    )}

                    <h6 className='mb-2'>{i18n.t('hospitality_banner_create.form.image_select')}</h6>
                    <p className='text-muted mb-3'>{i18n.t('hospitality_banner_create.form.image_formats')}</p>
                    <input
                      type='file'
                      accept='.jpg, .jpeg, .png, .gif'
                      onChange={async (value: React.BaseSyntheticEvent) => {
                        const file = value.target.files[0]
                        if (file) {
                          const result = await validateImage(file)
                          if (result) {
                            // Se result é um File (imagem redimensionada ou original válida)
                            setImage(result)
                          } else {
                            // Limpar o input se a imagem não for válida ou usuário cancelou
                            value.target.value = ''
                          }
                        }
                      }}
                      className='form-control'
                    />
                    <small className='text-muted'>{i18n.t('hospitality_banner_create.form.image_optional')}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Botões de Ação */}
        <div className='d-flex justify-content-between pt-8 mt-8 border-top'>
          <Button
            text={i18n.t(`buttons.back`)}
            color='secondary'
            size='small'
            horizontalPadding={6}
            btnAttr={{
              type: 'button',
            }}
            click={() => navigate('/hospitality/publicity-banner')}
            btnClass='fw-bolder'
          />
          <Button
            text={i18n.t('hospitality_banner_update.save_button')}
            color='primary'
            size='small'
            horizontalPadding={5}
            btnAttr={{
              type: 'button',
            }}
            click={updatePublicidade}
            btnClass='fw-bolder'
            disabled={loading}
          />
        </div>
      </div>
    </>
  )
}

const EditarPublicidadeBannerHotel: FC = () => {
  const { id } = useParams<{ id: string }>()

  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: false },
          { title: i18n.t('hospitality_banner_create.breadcrumb.hospitality'), path: 'hospitality', isActive: false },
          { title: i18n.t('hospitality_banner_create.breadcrumb.publicity'), path: 'hospitality/publicity-banner', isActive: false },
          { title: i18n.t('hospitality_banner_update.breadcrumb.edit'), path: `hospitality/publicity-banner/edit/${id}`, isActive: true },
        ]}
      >
        {i18n.t('hospitality_banner_update.page_title')}
      </PageTitle>
      <ContaContent />
    </>
  )
}

export { EditarPublicidadeBannerHotel }
